import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import withSOSAuth from '@/hocs/withSOSAuth';

/**
 * ProtectedRoute - Wraps a component with authentication HOC and Suspense
 * @param {Object} props - Component props
 * @param {React.ComponentType} props.component - Component to protect and lazy load
 * @return {JSX.Element} Protected route with Suspense wrapper
 */
const ProtectedRoute = ({ component: Component }) => {
  const ProtectedComponent = withSOSAuth(Component);

  return (
    <Suspense fallback={null}>
      <ProtectedComponent />
    </Suspense>
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default ProtectedRoute;
